import React from 'react';
import _ from 'lodash';
import { animatedScrollTo, isElemInViewport } from '../../utils/utils';
import { FMessage } from '../../hoc/IntlComponents';

export const hasErrorInScript = ({errors, errorPath, scrKey}) => {
  return _.get(errors, `${errorPath}[${scrKey}]`);
};

export const hasErrorInOption = ({errors, errorPath, scrKey, optKey}) => {
  return _.get(errors, `${errorPath}[${scrKey}][${optKey}]`);
};

export const scrollToError = (_alertRefs, keys) => {
  const ref = _.get(_alertRefs, _.join(keys, ''));
  if (ref && ref.current) {
    const elInViewPort = isElemInViewport(ref.current);
    if(!elInViewPort) {
      animatedScrollTo(ref.current, 400, 80);
    }
  }
};

const errorMessages = {
  titleError: <FMessage id="flow.errors.no-title"/>,
  flowError: <FMessage id="flow.errors.no-flow"/>,
  defaultStreamsErrors: <FMessage id="flow.errors.no-flow"/>,
  scriptsTitlesErrors: <FMessage id="flow.errors.no-title"/>,
  scriptsOptionsTypeErrors: <FMessage id="streamTDS.errors.no-option-type"/>,
  scriptsOptionsValueErrors: <FMessage id="streamTDS.errors.no-option-value"/>,
};

export const getErrorMessage = type => errorMessages[type];